import { AdvancedReportMetricRow } from 'features/advanced-reports/advanced-reports.types';
import {
  InsightsTableCell,
  InsightsTableRow
} from './types/insights-table.types';
import { InsightsMetricRowsResult } from './types/insights.types';

export const createInsightRows = (
  primaryMetrics: InsightsMetricRowsResult
): InsightsTableRow[] => {
  const allMetrics = [...primaryMetrics.insights];

  const unqiueMetricIdsSet = new Set<string>([
    ...allMetrics.map((metric) => metric.metricId)
  ]);

  const unqiqueMetricIds = [...unqiueMetricIdsSet];
  const metricRows = unqiqueMetricIds.map((metricId) => {
    const metric = allMetrics.find((m) => m.metricId === metricId)!;

    const row: InsightsTableRow = {
      id: metricId,
      parentId: metric.metricParentId,
      hasChildren: allMetrics.some((m) => m.metricParentId === metricId),
      depth: metric.depth,
      field: metric.metricTypeName,
      occurrences: createCellByMetricId(primaryMetrics.insights, metricId)
    };

    return row;
  });

  return metricRows;
};

const createCellByMetricId = (
  primaryMetrics: AdvancedReportMetricRow[],
  metricId: string
): InsightsTableCell => {
  const cell: InsightsTableCell = {
    primaryValue: getSummedMetricValuesById(primaryMetrics, metricId)
  };

  return cell;
};

function getSummedMetricValuesById(
  metrics: AdvancedReportMetricRow[],
  metricId: string
): number {
  const summedMetrics = metrics
    .filter((metric) => metric.metricId === metricId)
    .map((metric) => metric.metricValue)
    .reduce((total, metricValue) => (total += metricValue), 0);

  return summedMetrics;
}
